import { Injectable } from '@angular/core';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getApiUrl } from '..';
import { ContactPayload } from '../../shared/models';

@Injectable({
  providedIn: 'root'
})
export class MailService {
  private apiUrl = getApiUrl();

  // Set the headers
  config: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  constructor() {
    console.log(this.apiUrl);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async sendMail(formData: ContactPayload): Promise<AxiosResponse<any>> {
    const url = `${this.apiUrl}/api/v1/send-email`;

    try {
      const response = await axios.post(url, formData, this.config);
      return response; // Return the full response
    } catch (error) {
      // Handle error as n  eeded
      console.error('Error sending email:', error);
      throw error; // Rethrow the error for further handling if needed
    }
  }
}
